<template>
    <div  :class="['view-chart', { fullscreen }]"  :id="`view-chart-${chart.chartId}`">
        <div class="view-chart-legend-wrapper" >
            <ViewChartLegend :chart="chart"
                             :class="[{ fullscreen }]"
                             :defaultLegendSort="chart.filters.legendSort"
                             :defaultShowLoe="chart.filters.showLoe"
                             :defaultLogScale="chart.filters.scaleLogType"
                             :defaultShowStopIcon="chart.filters.showStopIcon"
                             :defaultColorByFicBic="chart.filters.colorByFicBic"
                             :style="{ visibility: chartHasData ? 'visible' : 'hidden' }"
                              @modifyLoe="handleOnModifyLoe" >
            </ViewChartLegend>
        </div>
        <div style="flex-grow: 1; flex-shrink: 1;  min-width: 0;">
        <ViewChartTags
            :chart="chart"
            :chartTypes="chartTypes"
            :cumulativeTypes="cumulativeTypes"
            :growthRates="growthRates"
            :growthRatesQuarters="growthRatesQuarters"
            :companies="companies"
            :categories="categories"
            :subcategories="subcategories"
            :classes="classes"
            :brands="brands"
            :excludeBrands="excludeBrands"
            :quarterData="quarterData"
            :tags="tags"
            :ranges="ranges"
            :revenueFilterRanges="revenueFilterRanges"
            @exportChart="exportChart"
            @exportChartPng="exportChartPng"
            @exportChartCsv="exportChartCsv">
        </ViewChartTags>
        <div
            :id="`chart-drawing-${chart.chartId}-wrapper`"
            :class="['chart-drawing-wrapper', { fullscreen }]"
            :style="{ height: chartHeight }"
            v-show="chartHasData || chart.loading"
        >
            <div class="chart-axis-header">
                <div class="axis-legend left-axis-legend">$MIL</div>
                <div class="right-axis-header">
                    <div class="axis-legend right-axis-legend">$MIL</div>
                    <div v-if="chartHasCumulativeRevenueData"  class="axis-legend right-axis-legend">$MIL</div>
                </div>
            </div>
            <div class="chart-drawing" :id="`chart-drawing-${chart.chartId}`" :style="{ height: chartHeight }"></div>
            <ViewChartToolbar :chart="chart" @fullscreen="toggleFullscreen"  @exportChartPng="exportChartPng"   @exportChartCsv="exportChartCsv" v-if="chartHasData"></ViewChartToolbar>
            <div class="chart-view-buttons" v-if="chartHasData">
                <v-btn class="break-apart-button" ref="breakApartButton" depressed
                    v-if="chart.filters.cumulativeType!=='none'  &&  chart.filters.cumulativeType!==null   &&  chart.filters.cumulativeType!=='' "
                    @click="breakApartCumulative"
                >
                    Break Apart
                </v-btn>

                <v-btn class="break-apart-button" ref="breakApartButton" depressed
                       v-if="isGrowthRateGraph"
                       @click="breakApart"
                >
                    Break Apart
                </v-btn>
                <v-btn class="view-details-button" ref="viewDetailsButton" depressed
                    v-if="!isGrowthRateGraph && (chart.filters.cumulativeType=='none'  ||  chart.filters.cumulativeType==null) "
                    @click="openViewDetails"
                >
                    View Details
                </v-btn>
                <v-btn class="view-competitors-button" ref="viewCompetitorsButton" depressed
                    v-if="!isGrowthRateGraph  && (chart.filters.cumulativeType=='none'  ||  chart.filters.cumulativeType==null) "
                    @click="openViewCompetitors"
                >
                    View Competitors
                </v-btn>
            </div>
            <!--Chart Tooltip-->
            <Tooltip position="right" className="chart-tooltip closed">
                <h4></h4>
                <div class="divider"></div>
                <div class="event-text"></div>
                <p class="event-revenue"></p>
                <p class="event-quarter"></p>
            </Tooltip>
            <!-- ./Chart Tooltip-->
            <!--Toolbar Tooltip-->
            <Tooltip position="top" className="toolbar-tooltip closed">
                <h4></h4>
                <div class="divider"></div>
                <div class="event-text"></div>
                <p class="event-revenue"></p>
                <p class="event-quarter"></p>
            </Tooltip>
            <!-- ./Toolbar Tooltip-->
        </div>
        <div class="chart-no-results" v-show="!chartHasData && !chart.loading">
            <div class="chart-no-results-inner">
                <img src="../../assets/images/no-results.svg" alt="No Results">
                <h4>No results found.</h4>
                <h6>Please try fewer or different filters</h6>
            </div>
        </div>
            <div class="scopic-logo">
                <img src="../../assets/images/scopic-logo.svg" >

            </div>

        <Filters
            :filters="chart.filters"
            :chartTypes="chartTypes"
            :cumulativeTypes="cumulativeTypes"
            :growthRates="growthRates"
            :growthRatesQuarters="growthRatesQuarters"
            :companies="companies"
            :categories="categories"
            :subcategories="subcategories"
            :classes="classes"
            :ranges="ranges"
            :revenueFilterRanges="revenueFilterRanges"
            :brands="brands"
            :excludeBrands="excludeBrands"
            :quarterData="quarterData"
            :tags="tags"
            ref="filters"
            @apply="applyFilters">
        </Filters>
        <ViewCompetitors :chart="chart"></ViewCompetitors>
        <ViewDetails :chart="chart"></ViewDetails>
        <ViewFinePrint :fine-print="finePrint"></ViewFinePrint>
        <ViewCumulativeGroupWarning :key="filterChanged" :chart="chart"></ViewCumulativeGroupWarning>
        <ModifyLoeDate v-if="selectedLoe != null" :selectedLoe="selectedLoe" :legendId="legendId" @close="selectedLoe = null"></ModifyLoeDate>
        <PortalTarget name="modals" multiple></PortalTarget>
        </div>
    </div>
</template>

<script>
import {PortalTarget} from 'portal-vue'
import Filters from './FiltersComponent.vue';
import ViewChartTags from './ViewChart/TagsComponent.vue';
import ViewChartToolbar from './ViewChart/ToolbarComponent.vue';
import ViewChartLegend from './ViewChart/LegendComponent.vue';
import ViewCompetitors from './ViewChart/ViewCompetitorsComponent.vue';
import ViewDetails from './ViewChart/ViewDetailsComponent.vue';
import Tooltip from '../common/Tooltip.vue';
import ViewFinePrint from './ViewChart/FinePrintComponent.vue';
import ViewCumulativeGroupWarning from './ViewChart/CumulativeGroupWarningComponent.vue';
import ModifyLoeDate from './ViewChart/ModifyLoeDate.vue';

import filters from '../../constants/filters';

import domtoimage from 'dom-to-image-more';
import { saveAs } from 'file-saver';

export default {
    props: {
        chart: {
            type: Object,
        },
        chartTypes: {
            type: Array,
        },
        cumulativeTypes: {
            type: Array,
        },
        growthRates: {
            type: Array,
        },
        growthRatesQuarters: {
            type: Array,
        },
        companies: {
            type: Array,
        },
        categories: {
            type: Array,
        },
        subcategories: {
            type: Array,
        },
        classes: {
            type: Array,
        },
        ranges: {
            type: Array,
        },
        revenueFilterRanges: {
            type: Array,
        },
        brands: {
            type: Array,
        },
        excludeBrands: {
            type: Array,
        },
        quarterData: {
            type: Array,
        },
        tags: {
            type: Array,
        },
        height: {
            type: Number,
        },
        finePrint: {
            type: Array,
        },
    },
    components: {
        PortalTarget,
        Filters,
        ViewChartTags,
        ViewChartToolbar,
        ViewChartLegend,
        ViewCompetitors,
        ViewDetails,
        Tooltip,
        ViewFinePrint,
        ViewCumulativeGroupWarning,
        ModifyLoeDate,
    },
    data() {
        return {
            fullscreen: false,
            filterChanged: false,
            selectedLoe: null,
            legendId: null,
        };
    },
    computed: {
        chartHasData() {
            return Object.keys(this.chart.data).length > 0;
        },
        chartHasCumulativeRevenueData() {
            return this.chart.cumulativeData !== undefined 
                    && this.chart.cumulativeData !== null;
        },
        isGrowthRateGraph() {
            return this.chart.filters.chartType === 'growth'
                && !this.chart.filters.breakApart
                && !this.chart.filters.viewCompetitors;
        },
        chartHeight() {
            return `${this.height - 70}px`;
        },
    },
    created() {
        this.$emit('loading');
    },
    mounted() {
        this.$nextTick(async () => {
            if (this.chartHasData) {
                await this.$store.dispatch('chart/drawGraph');
            }

            this.$emit('loaded');

            window.addEventListener('resize', () => {
                if (typeof this.chart.drawingService !== 'undefined') this.chart.drawingService.resize();
            });

            setTimeout(() => {
                if (typeof this.chart.drawingService !== 'undefined' && this.chart.drawingService!== null) this.chart.drawingService.resize();
            }, 0);
        });
    },
    methods: {
        async applyFilters(filtersData) {
            await this.$store.dispatch('chart/applyFilters', { filters: filtersData });
            this.$root.$emit('updateLegends');
            this.filterChanged = !this.filterChanged;
        },
        toggleFullscreen(fullscreen) {
            this.fullscreen = fullscreen;

            this.$nextTick(() => {
                this.chart.drawingService.resize();
            });
        },
        openViewCompetitors() {
            const drugId = this.$refs.viewCompetitorsButton.$el.getAttribute('data-id');
            const drugName = this.$refs.viewCompetitorsButton.$el.getAttribute('data-name');
            this.$store.commit('chart/toggleViewCompetitors', { drugId, drugName, isOpen: true });
        },

        /**
         * @deprecated
         */
        exportChart() {
            var legendExport = document.querySelector('.legend').cloneNode(true);
            legendExport.id = 'print-legend-container';
            legendExport.style.visibility = 'visible';
            legendExport.classList.add('expanded');

            // improve text styles of legend
            var labels = legendExport.querySelectorAll('.legend-item-label');
            var colorLabels = legendExport.querySelectorAll('.legend-item-color');
            legendExport.querySelector('.legend-show-more').remove();
            legendExport.querySelector('.legend-label').remove();
            for(var i=0; i<labels.length; ++i) {
              labels[i].style.fontSize = "22px";
              labels[i].style.color = "black";
              labels[i].style.fontWeight = "bold";
              labels[i].style.fontFamily = "Axiforma";
            }
            for(var i=0; i<colorLabels.length; ++i) {
              colorLabels[i].style.width = "60px";
              colorLabels[i].style.height = "20px";
              colorLabels[i].style.borderRadius = "10px";
              colorLabels[i].style.fontFamily = "Axiforma";
            }
            document.body.appendChild(legendExport);

            this.$store.commit('chart/setChartLoading', true); // show loader

            var v = this;
            // download image
            domtoimage.toBlob(legendExport)
            .then(function (blob) {
                window.saveAs(blob, 'legend-export.png');
                document.getElementById('print-legend-container').remove(); // remove legend duplicated

                // start creating chart svg export file

                const xmlns = "http://www.w3.org/2000/xmlns/";
                const xlinkns = "http://www.w3.org/1999/xlink";
                const svgns = "http://www.w3.org/2000/svg";

                //svg = svg.cloneNode(true);
                const svg = document.querySelector('#chart-drawing-1 svg').cloneNode(true); // clone your original svg
                const fragment = window.location.href + "#";
                const walker = document.createTreeWalker(svg, NodeFilter.SHOW_ELEMENT, null, false);
                while (walker.nextNode()) {
                  for (const attr of walker.currentNode.attributes) {
                    if (attr.value.includes(fragment)) {
                      attr.value = attr.value.replace(fragment, "#");
                    }
                  }
                }

                // show oxDots quarters
                var oxDots = svg.querySelectorAll('.tick .dot');
                for(var i=0; i<oxDots.length; ++i) {
                  oxDots[i].style.color = "#3e3e3e";
                  oxDots[i].style.fontSize = "50px";
                  oxDots[i].style.fontFamily = "Axiforma";
                }

                // remove circles & dots
                var indicationDots = svg.querySelectorAll('.event-indication');
                Array.prototype.forEach.call( indicationDots, function( node ) {
                    node.parentNode.removeChild( node );
                });

                var eventMarketDots = svg.querySelectorAll('.event-market');
                Array.prototype.forEach.call( eventMarketDots, function( node ) {
                    node.parentNode.removeChild( node );
                });

                var Circles = svg.querySelectorAll('circle');
                Array.prototype.forEach.call( Circles, function( node ) {
                    node.parentNode.removeChild( node );
                });
                // end remove circles & dots

                // remove background black for y axis
                var rects = svg.querySelectorAll('.vertical-dragger');
                Array.prototype.forEach.call( rects, function( node ) {
                    node.parentNode.removeChild( node );
                });

                // remove background black
                var paths = svg.querySelectorAll('path');
                for(var i=0; i<paths.length; ++i) {
                  paths[i].style.fill = "none";
                }

                var pathsDomain = svg.querySelectorAll('path.domain');
                for(var i=0; i<pathsDomain.length; ++i) {
                  pathsDomain[i].style.fill = "none";
                  pathsDomain[i].style.stroke = "gray";
                  pathsDomain[i].style.strokeOpacity = "0.7";
                  pathsDomain[i].style.strokeDasharray = "5,5";
                }

                // add dotted x axes, last ox line will be solid
                var xAxesLines = svg.querySelectorAll('.x-axis .tick line');
                for(var i=0; i<xAxesLines.length; ++i) {
                  if (i < xAxesLines.length - 1) {
                    xAxesLines[i].style.fill = "none";
                    xAxesLines[i].style.stroke = "gray";
                    xAxesLines[i].style.strokeOpacity = "0.7";
                    xAxesLines[i].style.strokeDasharray = "5,5";
                  }
                }
                // add dotted y axes, last oy line will be solid
                var yAxesLines = svg.querySelectorAll('.y-axis .tick line');
                for(var i=0; i<yAxesLines.length; ++i) {
                  if (i > 0) {
                    yAxesLines[i].style.fill = "none";
                    yAxesLines[i].style.stroke = "gray";
                    yAxesLines[i].style.strokeOpacity = "0.7";
                    yAxesLines[i].style.strokeDasharray = "5,5";
                  }
                }

                svg.setAttributeNS(xmlns, "xmlns", svgns);
                svg.setAttributeNS(xmlns, "xmlns:xlink", xlinkns);
                const serializer = new window.XMLSerializer;
                const string = serializer.serializeToString(svg);
                const link = document.createElement("a");
                document.body.appendChild(link);
                link.setAttribute("href", `data:image/svg+xml,${encodeURIComponent(string)}`);
                link.setAttribute("download", "chart-export.svg");
                link.click();

                v.$store.commit('chart/setChartLoading', false); // hide loader
            });
        },
        exportChartPng() {
            this.toggleFullscreen(true);
            this.$store.commit('chart/setChartLoading', true); // show loader

            let that = this;
            this.$nextTick(() => {

                var svg = document.getElementById(`view-chart-${this.chart.chartId}`);
                svg.querySelector('.filter-tags').style.display = 'none';
                svg.querySelector('.chart-filters').style.display = 'none';
                svg.querySelector('.view-competitors').style.display = 'none';
                svg.querySelector('.view-details').style.display = 'none';
                svg.querySelector('.chart-drawing-toolbar').style.display = 'none';
                svg.querySelector('.chart-view-buttons').style.display = 'none';
                svg.querySelector('.options-dd-btn').style.display = 'none';
                svg.querySelector('.tooltip').style.display = 'none';
                svg.querySelector('.toolbar-tooltip').style.display = 'none';
                svg.querySelector('.ps__rail-x').style.display = 'none';
                svg.querySelector('.ps__rail-y').style.display = 'none';
                svg.querySelectorAll('.add-loe-date').forEach((node) => node.style.display = 'none');
                //
                that.chart.drawingService.resize();
                svg.classList.add('fullscreen');
                svg.querySelector('.chart-drawing-wrapper').classList.add('fullscreen');
                svg.querySelector('.scopic-logo').style.display = 'block';

                svg.style.backgroundColor = "white";
                svg.style.zIndex = "0";

                //.chart-cover
                var cover = document.getElementById(`chart-cover-${this.chart.chartId}`);
                cover.style.opacity=".9";
                cover.style.borderRadius="0";
                var loading = document.getElementById(`chart-loading-${this.chart.chartId}`);
                loading.style.display = 'flex';
                loading.style.zIndex = "100000000000000";


                // check if we need to show the "more legends" label
                const rootHeight = svg.querySelector('.legend-inner').offsetHeight;
                const itemsHeight = svg.querySelector('.legend-items').offsetHeight;
                const hiddenLegends = itemsHeight > rootHeight;
                if (svg.querySelector('.legend-more-tag') && hiddenLegends) svg.querySelector('.legend-more-tag').style.display = 'block';

                // Scale Dom to increase png resolution
                const scale = 4;
                //
                domtoimage.toPng(svg, {
                    width: svg.clientWidth * scale,
                    height: svg.clientHeight * scale,
                    quality: 0.95,
                    style: {
                        transform: 'scale(' + scale + ')',
                        transformOrigin: 'top left',
                    }
                }).then(function (dataUrl) {
                    const name=(that.chart.name) ? that.chart.name : 'chart-'+ that.chart.filters.chartType;
                    window.saveAs(dataUrl, name+'.png');
                    that.$store.commit('chart/setChartLoading', false); // show loader
                }).catch(function (error) {
                    console.error('oops, something went wrong!', error)
                    that.$store.commit('chart/setChartLoading', false); // show loader
                }).finally(function () {

                    // reset settings
                    svg.querySelector('.filter-tags').style.display = 'flex';
                    svg.querySelector('.chart-filters').style.display = 'flex';
                    svg.querySelector('.view-competitors').style.display = 'flex';
                    svg.querySelector('.view-details').style.display = 'flex';
                    svg.querySelector('.chart-drawing-toolbar').style.display = 'flex';
                    svg.querySelector('.chart-view-buttons').style.display = 'flex';
                    svg.querySelector('.options-dd-btn').style.display = 'inline-block';
                    svg.querySelector('.tooltip').style.display = 'flex';
                    svg.querySelector('.toolbar-tooltip').style.display = 'flex';
                    svg.querySelector('.ps__rail-x').style.display = 'block';
                    svg.querySelector('.ps__rail-y').style.display = 'block';
                    svg.querySelectorAll('.add-loe-date').forEach((node) => node.style.display = 'flex');
                    //
                    svg.classList.remove('fullscreen');
                    svg.querySelector('.chart-drawing-wrapper').classList.remove('fullscreen');
                    svg.querySelector('.scopic-logo').style.display = 'none';
                    if (svg.querySelector('.legend-more-tag') ) svg.querySelector('.legend-more-tag').style.display = 'none';
                    svg.style.zIndex = "1000000";
                    that.toggleFullscreen(false);
                    loading.style.zIndex = "-1";
                    cover.style.opacity=".4";
                    cover.style.borderRadius="0 15px 15px 15px";
                    that.chart.drawingService.resize();
                });
            });
        },
        async exportChartCsv() {
            this.$store.commit('chart/setChartLoading', true); // show loader
                await this.$store.dispatch('chart/exportChartCsv' );
        },
        async openViewDetails() {
            const drugId = this.$refs.viewDetailsButton.$el.getAttribute('data-id');
            const drugName = document.querySelector(`.legend-item-${drugId}`).getAttribute('data-brand-name');
            const companyName = document.querySelector(`.legend-item-${drugId}`).getAttribute('data-company-name');

            await this.$store.dispatch('chart/viewDetails', { drugId, drugName, companyName });
        },
        async breakApart() {
            const rateValue = this.$refs.breakApartButton.$el.getAttribute('data-id');
            await this.$store.dispatch('chart/breakApart', {
                firstInit: true,
                parentChartType: this.chart.filters.chartType,
                rateData: this.chart.data[rateValue],
                rateName: filters.growthRates.find(growthRate => growthRate.value === rateValue).text,
                filters: Object.assign({}, this.chart.filters, {
                    growthRates: [rateValue],
                }),
            });
        },
        async breakApartCumulative() {
            const itemId = this.$refs.breakApartButton.$el.getAttribute('data-id');
            await this.$store.dispatch('chart/breakApartCumulative', {
                firstInit: true,
                parentChartType: this.chart.filters.chartType,
                itemId:itemId,
            });
        },
        handleOnModifyLoe(id, date){
            this.legendId = id;
            this.selectedLoe = date;
        }
    },
};

</script>

<style lang="scss">
    @import '../../style/Charts/ViewChartComponent.scss';
</style>
